import React from 'react';
import { PawPrintIcon } from 'lucide-react';
import { useAppState } from '../../contexts/AppStateContext';
import { useUi } from '../../contexts/UiContext';
import { DEMO_DATE } from '../../data/demo';
import { frequencyLabel } from '../../data/labels';
import { isDoneStatus } from '../../utils/progress';
import { isDueOn } from '../../utils/today';
import { namesOf } from '../../utils/members';
import { formatDate } from '../../utils/time';
import { Button } from '../ui/Button';
import { EmptyNote } from '../ui/Panel';
export function AnimalsBoard() {
  const {
    family,
    getOcc,
    memberById,
    markShared,
    viewer
  } = useAppState();
  const {
    openTask: openTaskFromBoard
  } = useUi();
  if (!family.modules.zivali || family.animals.length === 0) return <EmptyNote data-id="element-122" data-mp="390t5p875viow">Ta družina nima živali – in zato tudi ne njihovih obveznosti.</EmptyNote>;

  // Skupno bivališče (npr. dva polha) je en sklop oskrbe, ne dva.
  const groups = new Map<string, typeof family.animals>();
  family.animals.forEach(a => {
    const key = a.habitat ?? a.id;
    groups.set(key, [...(groups.get(key) ?? []), a]);
  });
  return <ul className="grid gap-3 md:grid-cols-2 xl:grid-cols-3" data-id="element-123" data-mp="3ofy0pbezxseb">
      {Array.from(groups.entries()).map(([key, animals]) => {
      const ids = animals.map(a => a.id);
      const tasks = family.templates.filter(t => t.animalIds?.some(id => ids.includes(id)));
      const shared = animals[0].caretakerIds.length === 0;
      return <li key={key} className="flex flex-col rounded-3xl border-[1.5px] border-line bg-surface p-4" data-id="element-124" data-mp="30ldfil56p5fs">
            <div className="flex items-start gap-3" data-id="element-125" data-mp="39jp3sgikvr52">
              <span className="grid h-10 w-10 shrink-0 place-items-center rounded-2xl bg-sun-soft text-sun-ink" data-id="element-126" data-mp="39ixko5663lvo">
                <PawPrintIcon className="h-5 w-5" aria-hidden="true" data-id="element-127" data-mp="3ek3ds43qpb5q" />
              </span>
              <span className="min-w-0 flex-1" data-id="element-128" data-mp="osydhxwy5gu4">
                <span className="block font-display text-lg font-semibold leading-tight" data-id="element-129" data-mp="tsaz6fc30hv4">{animals.map(a => a.name).join(' in ')}</span>
                <span className="block text-xs text-muted" data-id="element-130" data-mp="2pueedn6fw5lu">
                  {animals[0].species}
                  {animals[0].habitat ? ` · ${animals[0].habitat}` : ''} · {shared ? 'sprotni dogovor' : `skrbi ${namesOf(family, animals[0].caretakerIds)}`}
                </span>
                {animals.some(a => !a.confirmed) && <span className="mt-1 inline-block rounded-full bg-review-soft px-2 py-0.5 text-xs font-bold text-review-ink" data-id="element-131" data-mp="2uvbyi5b0f9pz">povezava še ni potrjena</span>}
              </span>
            </div>
            <ul className="mt-3 space-y-1.5" data-id="element-132" data-mp="227pu4utyk122">
              {tasks.map(t => {
            const o = getOcc(t.id);
            const due = isDueOn(t, DEMO_DATE);
            const done = isDoneStatus(o.status);
            return <li key={t.id} className="flex items-center gap-2 text-sm" data-id="element-133" data-mp="1oegjyry6rbih">
                    <span className={`h-2.5 w-2.5 shrink-0 rounded-full ${done ? 'bg-done' : due ? 'bg-accent' : 'bg-line'}`} aria-hidden="true" data-id="element-134" data-mp="1ocdq1wtwwy8h" />
                    <button type="button" onClick={() => openTaskFromBoard(t.id)} className="min-w-0 flex-1 text-left hover:underline" data-id="element-135" data-mp="3v1xq5win8u2j">
                      {t.title.replace(`${animals[0].name} – `, '')}
                      <span className="block text-xs text-muted" data-id="element-136" data-mp="3m3lqz63ponyh">
                        {frequencyLabel(t.frequency)}
                        {!due && t.nextDue ? ` · naslednjič ${formatDate(t.nextDue)}` : ''}
                        {done ? ` · naredil(a) ${o.performerId === viewer.id ? 'ti' : memberById(o.performerId)?.name ?? ''}` : ''}
                      </span>
                    </button>
                    {shared && due && !done && o.status !== 'v_pregledu' && <Button size="sm" variant="secondary" onClick={() => markShared(t.id)} data-id="element-137" data-mp="dlpn6ezm3xge">
                        Jaz sem
                      </Button>}
                  </li>;
          })}
            </ul>
          </li>;
    })}
    </ul>;
}